<template>
  <div :class="'collections'">
    <template v-for="({collection}, idxGroup) in groups">
      <SliderButtons v-if="idxGroup === selectGroup" :key="'group' + idxGroup" :options="swiperOption">
        <swiper-slide v-for="({image, title}, idx) in collection" :key="'col' + idx">
          <CollectionCard
            :image="image"
            :is-play.sync="isPlayed[idxGroup][idx]"
            :title="title"
            @playPause="(isPlay) => onPlayPause(idxGroup, idx, isPlay)"
          />
        </swiper-slide>
      </SliderButtons>
      <audio
        v-for="({music}, idxAudio) in collection"
        :key="`aud${idxGroup}-${idxAudio}`"
        :ref="audioRef(idxGroup, idxAudio)"
        :src="music"
        crossorigin="anonymous"
        loop="loop"
        preload="none"
      />
    </template>
  </div>
</template>
<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import CollectionCard from './CollectionCard.vue';
import CollectionCardSmall from './CollectionCardSmall.vue';
import SliderButtons from './SliderButtons.vue';

function updateSlide() {
  const copyFun = (from, to) => {
    for (let i = 0; i < from.length; i++) {
      from[i].__vue__ = to[i].__vue__;
      from[i].swiper = to[i].swiper;
      copyFun(from[i].children, to[i].children);
    }
  };
  const wrapperEl = this.$wrapperEl;
  const params = this.params;

  wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass).each(function () {
    const idx = this.getAttribute('data-swiper-slide-index');
    const el = wrapperEl.children(
      '.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')'
    );
    this.innerHTML = el.html();

    this.__vue__ = el[0].__vue__; // swiper-slide
    this.parentElement.parentElement.swiper = el[0].parentElement.parentElement.swiper;
    copyFun(this.children, el[0].children);
  });
}

export default {
  name: 'Collections',
  components: {
    Swiper,
    SwiperSlide,
    SliderButtons,
    CollectionCard,
    CollectionCardSmall,
  },
  props: {
    groups: Array,
    selectGroup: Number,
  },
  data() {
    return {
      isPlayed: [],
      indexCardPlay: undefined,
      indexGroupPlay: undefined,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 16,
        initialSlide: 0,
        loop: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        observer: true,
        on: {
          observerUpdate: updateSlide,
          slideChangeTransitionStart: updateSlide,
          slideChangeTransitionEnd: function () {
            this.slideToLoop(this.realIndex, 0, false);
          },
        },
      },
      swiperOptionSmall: {
        slidesPerView: 3,
        initialSlide: 0,
        loop: true,
        observer: true,
        on: {
          observerUpdate: updateSlide,
          slideChangeTransitionStart: updateSlide,
          slideChangeTransitionEnd: function () {
            this.slideToLoop(this.realIndex, 0, false);
          },
        },
      },
    };
  },
  created() {
    const isPlayed = [];
    this.groups.forEach(({collection}, idx) => {
      isPlayed[idx] = [];
      this.$set(
        this.isPlayed,
        idx,
        collection.map(() => false)
      );
    });
  },
  methods: {
    onPlayPause(idxGroup, idx, isPlay) {
      if (isPlay) {
        if (this.indexCardPlay !== undefined && (this.indexGroupPlay !== idxGroup || this.indexCardPlay !== idx)) {
          this.$set(
            this.isPlayed,
            this.indexGroupPlay,
            this.isPlayed[this.indexGroupPlay].map(() => false)
          );
          this.$refs[this.audioRef(this.indexGroupPlay, this.indexCardPlay)][0].pause();
        }
        this.indexCardPlay = idx;
        this.indexGroupPlay = idxGroup;
      }
      this.isPlayed[idxGroup][idx] = isPlay;
      this.$set(this.isPlayed, idxGroup, this.isPlayed[idxGroup]);
      this.$refs[this.audioRef(idxGroup, idx)][0][isPlay ? 'play' : 'pause']();
    },
    audioRef(idxGroup, idx) {
      return `refAudio${idxGroup}-${idx}`;
    },
  },
};
</script>

<style scoped>
.collections {
  margin-left: auto;
  margin-right: auto;
}
@media (--viewport-desktop-small) {
  .collections {
    width: 970px;
    height: 163px;
  }
}
@media (--viewport-desktop-medium) {
  .collections {
    width: 90%;
    height: 211px;
  }
}
</style>
